import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertCustomFields from "./upsert";
import useCustomFields from "./use-custom-fields";
import usePageChange from "@hooks/use-page-change";
const CustomFields = () => {
    const {
        data: { fields = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        modalConfig,
        handleModalConfig,
        getCustomAttributes
    } = useCustomFields();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Custom Fields"
                breadcrumbItems={{
                    items: [
                        {
                            title : "Custom Fields",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: fields,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        subject="custom-fields"
                        action="create"
                        testId="add-custom-fields"
                        onClick={() => handleModalConfig()}
                        text="Add Custom Fields"/>
                }/>
            <UpsertCustomFields
                handleModal={handleModalConfig}
                modalConfig={modalConfig}
                getCustomAttributes={getCustomAttributes}/>
        </>
    );
};

export default CustomFields;
